import { atom } from 'recoil';

export const dateRangeAtom = atom<{
  startDate: Date;
  endDate: Date;
}>({
  key: 'agencyAdminFeventNewTableDateRangeAtom',
  default: (() => {
    const now = new Date();
    return {
      startDate: new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0),
      endDate: new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59),
    };
  })(),
});
